import Box from "@/components/Box";
import {
  dashboardMainLayoutPb,
  dashboardMainLayoutPt,
  dashboardMainLayoutPx,
  dashboardMainStackMaxWidth,
  dashboardPageMaxWidth,
  dashboardSidebarContentGap
} from "@/components/organisations/learningHub/dashboardLayout";
import styled from "styled-components";

import { SHOP_FILTER_DESKTOP_MIN_WIDTH } from "./shopFilterBreakpoints";
import { SHOP_BREAKPOINTS } from "./shopTheme";

const ShopFiltersRow = styled(Box)`
  display: block;

  @media screen and (min-width: ${SHOP_FILTER_DESKTOP_MIN_WIDTH}) {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    gap: ${dashboardSidebarContentGap[1]}px;
  }

  @media screen and (min-width: ${SHOP_BREAKPOINTS.md}) {
    gap: ${dashboardSidebarContentGap[2]}px;
  }
`;

const ShopFilterSidebarColumn = styled(Box)`
  display: none;

  @media screen and (min-width: ${SHOP_FILTER_DESKTOP_MIN_WIDTH}) {
    display: block;
    /* The sticky filter sticks inside this column, so the column must match the row height. */
    align-self: stretch;
  }
`;

const ShopPageContentContainer = styled(Box)`
  margin-left: auto;
  margin-right: auto;

  @media screen and (min-width: ${SHOP_FILTER_DESKTOP_MIN_WIDTH}) {
    margin-left: 0;
    margin-right: 0;
  }
`;

export default function ShopPageFiltersLayout({ filterSidebar, children, embedded = false }) {
  const filtersRow = (
    <ShopFiltersRow
      px={embedded ? 0 : dashboardMainLayoutPx}
      maxWidth={embedded ? "100%" : dashboardPageMaxWidth}
      mx="auto"
      width="100%"
    >
      <ShopFilterSidebarColumn flex="0 0 auto" flexShrink={0}>
        {filterSidebar}
      </ShopFilterSidebarColumn>
      <ShopPageContentContainer
        flex="1 1 0%"
        minWidth={0}
        maxWidth={dashboardMainStackMaxWidth}
        data-component-name="ShopPageContentContainer"
      >
        {children}
      </ShopPageContentContainer>
    </ShopFiltersRow>
  );

  if (embedded) {
    return filtersRow;
  }

  return (
    <Box
      bg="haze"
      pt={dashboardMainLayoutPt}
      pb={dashboardMainLayoutPb}
      data-component-name="ShopPageFiltersLayout"
    >
      {filtersRow}
    </Box>
  );
}
